import { render, staticRenderFns } from "./CreateFaqModal.vue?vue&type=template&id=6556bd11&scoped=true&"
import script from "./CreateFaqModal.vue?vue&type=script&lang=js&"
export * from "./CreateFaqModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6556bd11",
  null
  
)

export default component.exports